import { Box, ButtonBase } from '@mui/material';
import React from 'react';
import { MessageMediaType, MessageStatus } from 'types/chat/messages/common';
import MediaPlaceholderWrapper from 'ui-component/display/MediaPlaceholderWrapper';
import LoupeOutlinedIcon from '@mui/icons-material/LoupeOutlined';
import { MediaPreviewType, MessageListRefProps } from 'types/chat/props';
import { isValidUrl } from 'utils/helpers';
import FileUploadProgress from './FileUploadProgress';

interface ImageMessageProps {
  file: string;
  fileType: MessageMediaType;
  mediaNoteFormat: string | null;
  handleMediaPreview: (params: Partial<MediaPreviewType>) => void;
  status: MessageStatus | null | undefined;
  scrollToBottom: MessageListRefProps['scrollToBottom'];
  mediaShouldScrollBottomRef: React.MutableRefObject<boolean>;
}

const ImageMessage: React.FC<ImageMessageProps> = ({
  file,
  fileType,
  mediaNoteFormat,
  handleMediaPreview,
  status,
  scrollToBottom,
  mediaShouldScrollBottomRef,
}) => {
  return (
    <Box
      sx={{
        maxWidth: '100%',
        maxHeight: '100%',
        margin: '0 auto',
      }}
    >
      <ButtonBase
        sx={{
          maxWidth: '100%',
          maxHeight: '100%',
          display: 'block',
          borderRadius: 1,
          overflow: 'hidden',
          position: 'relative',
          cursor: 'zoom-in',
          margin: '0 auto',
        }}
        onClick={() =>
          status !== 'uploading' &&
          isValidUrl(file) &&
          handleMediaPreview({
            visible: true,
            file: file,
            type:
              fileType === 'gif' || mediaNoteFormat === 'gif'
                ? 'image'
                : mediaNoteFormat !== null && mediaNoteFormat !== undefined
                  ? mediaNoteFormat
                  : fileType,
          })
        }
      >
        {status !== 'uploading' && isValidUrl(file) && (
          <MediaPlaceholderWrapper isWaitUpload={false}>
            <LoupeOutlinedIcon
              sx={{
                fontSize: 40,
              }}
            />
          </MediaPlaceholderWrapper>
        )}
        {status === 'uploading' && <FileUploadProgress interval={300} />}

        <Box
          component={'img'}
          onLoad={() => mediaShouldScrollBottomRef.current && scrollToBottom(false)}
          src={file || ''}
          alt=""
          sx={{
            width: 'auto',
            height: 'auto',
            maxWidth: fileType === 'sticker' ? 200 : '100%',
            maxHeight: fileType === 'sticker' ? 200 : 400,
            borderRadius: 1,
            display: 'block',
          }}
        />
      </ButtonBase>
    </Box>
  );
};

export default ImageMessage;
